import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const SwingHandle: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 20L15.9951 20.1025C15.9472 20.573 15.573 20.9472 15.1025 20.9951L15 21H12L11.8975 20.9951C11.427 20.9472 11.0528 20.573 11.0049 20.1025L11 20V9.0148L6.70711 13.3077C6.31658 13.6982 5.68342 13.6982 5.29289 13.3077C4.90237 12.9172 4.90237 12.284 5.29289 11.8935L11 6.18637V4C11 3.44772 11.4477 3 12 3H15C15.5523 3 16 3.44772 16 4V20ZM14.5 19.5H12.5V4.5H14.5V19.5Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default SwingHandle;
